'use client';
import {useEffect, useMemo, useState} from 'react';
import Helmet from 'react-helmet';
import globalDomains from '@/utils/global-domains';
import {HELMET_META_DATA} from './helmet-meta-data';

const EventHelmet = () => {
  const [metaKeyword, setMetaKeyword] = useState('');
  const [metaDescription, setMetaDescription] = useState('');
  const [pageTitle, setPageTitle] = useState('');

  // meta data 셋팅
  useEffect(() => {
    const pathname = window.location.pathname.split('/');
    const pageKey =
      pathname[2] === 'soopi'
        ? `${pathname[2]}-${pathname[3]}`
        : pathname[2] || '';

    for (let item of HELMET_META_DATA) {
      if (item.key === pageKey) {
        setMetaKeyword(item.keyword);
        setMetaDescription(item.description);
        setPageTitle(item.title);
        break;
      }
    }
  }, []);

  return (
    <Helmet>
      <meta name='viewport' content='width=device-width, initial-scale=1.0' />
      <meta name='keyword' content={metaKeyword} />
      <meta name='description' content={metaDescription} />
      <title>{pageTitle} | SOOP</title>
      <link
        rel={'shortcut icon'}
        href={`${globalDomains.RES_AFREECATV}/favicon.ico`}
      />
      <link
        rel={'preload'}
        as={'image'}
        href={`${globalDomains.RES_AFREECATV}/images/afmain/img_thumb_profile.gif`}
      />
      <script
        async
        src={`${globalDomains.STATIC_AFREECATV}/asset/service/config/constant.js`}
      />
      <script
        async={false}
        type='text/javascript'
        src={`${globalDomains.RES_AFREECATV}/script/new_main/common_pm.js`}></script>
      <script
        async
        src={`${globalDomains.STATIC_M_AFREECATV}/js/app/lib/afreeca.link.js`}
      />
    </Helmet>
  );
};

export default EventHelmet;
